// Mock data for MAGNETO Servicios Informáticos landing page

export const companyInfo = {
  name: "MAGNETO Servicios Informáticos",
  logo: "https://customer-assets.emergentagent.com/job_magneto-networking/artifacts/v9gmlx3d_Logo_Magneto_png.png",
  email: "magnetocom@outlook.com",
  phone: "+573002141025",
  yearsExperience: 25
};

export const aboutUsContent = {
  title: "Acerca de Nosotros",
  paragraphs: [
    "MAGNETO Servicios Informáticos, es una empresa que se dedica a analizar y resolver los problemas que aquejan diariamente los usuarios de computadoras, siendo nuestros fuertes el servicio de soporte de primer nivel, con más de 25 años de experiencia. Somos certificados por Microsoft como MCSA (Microsoft Certified System Administrator), la cual asegura un conocimiento y soporte en sus plataformas. Encaminamos todos los esfuerzos a satisfacer las necesidades específicas de nuestros clientes y enfocamos el trabajo de manera que nuestro conocimiento y experiencia contribuya positivamente al éxito de las organizaciones y de las personas a quienes servimos, somos socios de negocios de Microsoft® y de Hewlett Packard®",
    "Tanto si busca Servicios para mejorar o reparar su plataforma tecnológica o Servicios específicos en redes y comunicaciones, tenemos lo que necesita a precios asequibles. En Magneto Servicios Informáticos, nuestro objetivo es proporcionar un servicio profesional, cortés y oportuno del más alto nivel.",
    "Explore nuestro sitio web para obtener más información acerca de Nosotros."
  ]
};

export const services = [
  {
    id: 1,
    title: "Networking",
    description: "Diseño, implementación y mantenimiento de redes empresariales. Optimizamos su infraestructura de red para máximo rendimiento y seguridad.",
    icon: "Network"
  },
  {
    id: 2,
    title: "Windows Server",
    description: "Administración experta de servidores Windows. Configuración, mantenimiento y soporte de Active Directory, políticas de grupo y servicios empresariales.",
    icon: "Server"
  },
  {
    id: 3,
    title: "Soporte a Usuarios de Escritorio",
    description: "Atención técnica de primer nivel para usuarios finales. Resolución rápida y eficiente de problemas en equipos de cómputo y aplicaciones.",
    icon: "Monitor"
  },
  {
    id: 4,
    title: "Contratos de Soporte",
    description: "Planes de soporte personalizados que se ajustan a las necesidades específicas de cada cliente. Mantenimiento preventivo y correctivo.",
    icon: "FileText"
  }
];

export const partners = [
  {
    name: "HP",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/150px-HP_logo_2012.svg.png"
  },
  {
    name: "Ubiquiti",
    logo: "https://ui.com/icons/logo.svg"
  },
  {
    name: "Microsoft",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/150px-Microsoft_logo.svg.png"
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1644088379091-d574269d422f",
  networking: "https://images.pexels.com/photos/5242294/pexels-photo-5242294.jpeg",
  serverRoom: "https://images.unsplash.com/photo-1580106815433-a5b1d1d53d85",
  support: "https://customer-assets.emergentagent.com/job_magneto-networking/artifacts/6eaimrnd_Technician.jpg"
};

// Mock contact submissions storage
export let contactSubmissions = [];

export const addContactSubmission = (submission) => {
  const newSubmission = {
    id: Date.now().toString(),
    ...submission,
    timestamp: new Date().toISOString()
  };
  contactSubmissions.push(newSubmission);
  return newSubmission;
};
